import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AuthorizationContainerComponent } from '../authorization-container/authorization-container.component';
import { MatIcon } from '@angular/material/icon';
import { FilledButtonComponent } from '@custom-components/general/button/filled-button/filled-button.component';

@Component({
  selector: 'xemex-reset-password-success-page',
  imports: [MatIcon, TranslateModule, AuthorizationContainerComponent, FilledButtonComponent],
  templateUrl: './reset-password-success-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './reset-password-success-page.component.scss',
})
export class ResetPasswordSuccessPageComponent {
  private readonly router = inject(Router);

  backToLogin() {
    this.router.navigate(['/auth/login']);
  }
}
